// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/share-2.js';

import { paths } from '../generated/share-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('share-2', Original, paths);
